import React from 'react'
import { Outlet } from 'react-router-dom'

export const Reproduction: React.FC = () => {
  return <Outlet />
}
